import * as React from 'react'

import { HashtagIcon, IconButton } from '@buffer-mono/popcorn'
import type { IconButtonProps } from '@buffer-mono/popcorn'

type HashtagManagerButtonProps = Omit<
  IconButtonProps,
  'label' | 'tooltip' | 'variant' | 'children'
>

export const HashtagManagerButton = React.forwardRef<
  HTMLButtonElement,
  HashtagManagerButtonProps
>((props, ref) => (
  <IconButton
    ref={ref}
    label="Hashtag Manager"
    variant="tertiary"
    tooltip="Hashtag Manager"
    {...props}
  >
    <HashtagIcon />
  </IconButton>
))

HashtagManagerButton.displayName = 'HashtagManagerButton'
